import { Flex } from '@chakra-ui/react';

import { Button, ButtonGroup } from '@revelio/ui';

import styles from './FilterSelectFooter.module.css';

export const FilterSelectFooter = ({
  onClose,
  onClearSelections,
  onAdd = () => undefined,
  addLabel = 'Add',
  isAddDisabled = false,
  onBack,
  loading = false,
}: {
  onClose: () => void;
  onClearSelections?: () => void;
  onAdd?: () => void;
  isAddDisabled?: boolean;
  addLabel?: string;
  onBack?: () => void;
  loading?: boolean;
}) => {
  return (
    <Flex justifyContent="space-between" alignItems="center" width="100%">
      <Flex>
        {onClearSelections && (
          <Button
            variant="ghost"
            size="sm"
            className={styles.fontXs}
            color="destructive"
            onClick={onClearSelections}
          >
            Clear Selections
          </Button>
        )}
        {onBack && (
          <Button
            variant="link"
            size="sm"
            className={styles.fontXs}
            onClick={onBack}
          >
            Back
          </Button>
        )}
      </Flex>
      <ButtonGroup style={{ gap: 'var(--ui-spacing-4)' }}>
        <Button
          variant="link"
          size="sm"
          className={styles.fontXs}
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          data-testid="filter-popover-submit"
          disabled={isAddDisabled}
          color="primary"
          variant="default"
          size="sm"
          className={styles.fontXs}
          onClick={onAdd}
          loading={loading}
        >
          {addLabel}
        </Button>
      </ButtonGroup>
    </Flex>
  );
};
